import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=3f493714&scoped=true&lang=pug"
import script from "./ChannelEdit.vue?vue&type=script&lang=js"
export * from "./ChannelEdit.vue?vue&type=script&lang=js"
import style0 from "./ChannelEdit.vue?vue&type=style&index=0&id=3f493714&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f493714",
  null
  
)

export default component.exports